import { useMutation } from "@apollo/client";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { onBoardTransition } from "../../animation/index";
import { SEEN_ONBOARD } from "../../app/apollo/index";
import { AuthenticationLayout } from "../../globalComponents/AuthenticationLayout";
import {} from "../../globalComponents/globalStyle";
import withAuthentication from "../../HOC/withAuth";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Skip, StepCount, StepsContainer } from "./Style";
const Onboard: React.FC = () => {
  const [seenOnBoard] = useMutation(SEEN_ONBOARD);
  useEffect(() => {
    try {
      const response = seenOnBoard({
        variables: {},
      });
      console.log("the response", response);
    } catch (e) {
      console.log(e.message);
    }
  }, []);
  const history = useHistory();
  const [current, setCurrent] = useState<number>(0);
  const next = (): void => {
    setCurrent(current + 1);
  };
  const prev = (): void => {
    setCurrent(current - 1);
  };

  const stepsComponent = [
    {
      content: <Step1 back={() => history.goBack()} next={next} />,
    },
    {
      content: <Step2 back={prev} next={() => history.push("/dashboard")} />,
    },
  ];
  return (
    <AuthenticationLayout>
      <div>
        {current === 1 ? (
          <motion.h3
            variants={onBoardTransition}
            exit="out"
            animate="in"
            initial="initial"
          >
            Enter Business Details
          </motion.h3>
        ) : (
          <motion.h3
            variants={onBoardTransition}
            exit="out"
            animate="in"
            initial="initial"
          >
            Enter Education Details
          </motion.h3>
        )}

        <StepsContainer>
          <StepCount active={current === 0 ? true : false}>1</StepCount>
          <hr />
          <StepCount active={current === 1 ? true : false}>2</StepCount>
        </StepsContainer>
        {stepsComponent[current].content}
        <Skip
          onClick={() => (current === 0 ? next : history.push("/destination"))}
        >
          Skip
        </Skip>
      </div>
    </AuthenticationLayout>
  );
};

export default withAuthentication(Onboard);
